import { render, staticRenderFns } from "./NativeCheckboxField.vue?vue&type=template&id=8cfb71d8"
import script from "./NativeCheckboxField.vue?vue&type=script&lang=js"
export * from "./NativeCheckboxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports